import React, { useState } from "react";
import { FiChevronDown, FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "../../assets/css/components/navbar.scss";
import miiLogo from "../../assets/images/mmiilogo.png";
import { useAuth } from "../../auth/AutoContextProvider";
import { dropdowns } from "./defaults";

const Menu = (e) => {
  let list = document.querySelector("ul");
  let targetElement = e.target;

  if (targetElement.getAttribute("name") === "menu") {
    targetElement.setAttribute("name", "close");
    list.classList.add("top-[60px]", "opacity-100");
  } else {
    targetElement.setAttribute("name", "menu");
    list.classList.remove("top-[60px]", "opacity-100");
  }
};

const NavBar = () => {
  const [state, { logout }] = useAuth();
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const toggleDropdown = (dropdownId) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  const handleDropdownOption = (option) => {
    console.log(`Selected option: ${option}`);
  };

  const NavbarDropdown = ({ dropdown, isActive }) => {
    const isButton = dropdown.isButton || dropdown.id === dropdowns.length;

    const handleDropdownClick = () => {
      toggleDropdown(dropdown.id);
    };

    return (
      <div
        className={`relative ${
          isActive ? "bg-white-900" : ""
        } hover:bg-white-900`}
      >
        {isButton ? (
          <button
            onClick={handleDropdownClick}
            className="px-4 py-2 bg-gradient-to-r from-homepage-buildmii-btnbg1 to-homepage-buildmii-btnbg2 rounded-full text-white-900 text-base font-bold hover:bg-gradient-to-r hover:from-homepage-discoverymii-btntxt hover:to-red-500 flex items-center "
          >
            <a href={dropdown.link} target="_blank" rel="noopener noreferrer">
              <div className="flex items-center z-[20]">
                <span className="ml-2">{dropdown.name}</span>
              </div>
            </a>
            {dropdown.options.length > 0 && <FiChevronDown className="ml-1" />}
          </button>
        ) : (
          <div
            onClick={handleDropdownClick}
            className={`px-4 py-2 rounded-md text-black hover:text-blue-500 flex items-center cursor-pointer ${
              isActive ? "text-blue-500" : ""
            } `}
          >
            <a
              href={dropdown.link}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-500"
            >
              <div className="flex items-center">
                <span className="ml-2">{dropdown.name}</span>
              </div>
            </a>
            {/* {dropdown.name} */}
            {dropdown.options.length > 0 && <FiChevronDown className="ml-1" />}
          </div>
        )}
        {isActive && dropdown.options.length > 0 && (
          <div className="origin-top-left absolute left-0 z-[20] mt-2 w-64 shadow-lg bg-white-700 ring-1 ring-black ring-opacity-5 border-t-4 border-blue-600">
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="dropdown-menu"
            >
              {dropdown.options.map((dropdownOption, index) => (
                <div
                  key={dropdownOption.name}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                  role="menuitem"
                  onClick={() => handleDropdownOption(dropdownOption)}
                >
                  <a
                    href={dropdownOption.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-blue-500"
                  >
                    <div className="flex items-center">
                      {dropdownOption.icon}
                      <span className="ml-2">{dropdownOption.name}</span>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    logout();
    navigate("/");
  };

  return (
    <div className="bg-white md:w-full w-[98%]">
      <nav className="flex flex-row h-full w-full bg-white-900 p-6 md:justify-between justify-between">
        <div className="flex flex-row h-full items-center justify-between"></div>
        <div className="flex flex-row">
          <div className="flex items-center">
            <a href="/Home" className="navbar-brand">
              <img
                src={miiLogo}
                alt="Logo"
                className="object-contain h-10 w-auto"
              />
            </a>
          </div>
        </div>
        <ul className="md:flex md:items-center md:z-auto md:static absolute w-full left-0 md:w-auto md:py-0 py-4 md:pl-0 pl-7 mt-0 md:opacity-100 opacity-0 md:bg-transparent bg-white-900 md:border-0 md:shadow-none shadow-lg md:border-none border-t-4 border-blue-500 top-[-400px] transition-all ease-in duration-500">
          <li className="flex mx-4 relative md:flex-row flex-col text-lg font-medium">
            {dropdowns.map((dropdown) => (
              <NavbarDropdown
                key={dropdown.id}
                dropdown={dropdown}
                isActive={activeDropdown === dropdown.id}
              />
            ))}
          </li>
        </ul>
        <div className="flex text-3xl cursor-pointer mx-2 md:hidden w-full justify-end">
          <ion-icon name="menu" onClick={(e) => Menu(e)}></ion-icon>
        </div>
        <div className="flex flex-row h-full items-center justify-between"></div>
      </nav>
    </div>
  );
};

export default NavBar;
